import { SelectApplicationMenuForUserGroupOutputData } from './select-application-menu-for-user-group-output-data.model';


export class UserGroupDetailsOutput implements IUserGroupDetailsOutput {
    /** The auto-generated id of the user group master */
    user_group_id!: number;
    /** The user group name with 255 character limit */
    user_group_name!: string;
    /** The auto-generated id of the application module master */
    application_module_id!: number;
    /** The auto-generated id of the user type master */
    user_type_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    menu_list!: SelectApplicationMenuForUserGroupOutputData[];
    status!: number;

    constructor(data?: IUserGroupDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_group_id = _data["user_group_id"];
            this.user_group_name = _data["user_group_name"];
            this.application_module_id = _data["application_module_id"];
            this.user_type_id = _data["user_type_id"];
            this.company_details_id = _data["company_details_id"];
            if (Array.isArray(_data["menu_list"])) {
                this.menu_list = [] as any;
                for (let item of _data["menu_list"])
                    this.menu_list!.push(SelectApplicationMenuForUserGroupOutputData.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserGroupDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_group_id"] = this.user_group_id;
        data["user_group_name"] = this.user_group_name;
        data["application_module_id"] = this.application_module_id;
        data["user_type_id"] = this.user_type_id;
        data["company_details_id"] = this.company_details_id;
        if (Array.isArray(this.menu_list)) {
            data["menu_list"] = [];
            for (let item of this.menu_list)
                data["menu_list"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserGroupDetailsOutput {
    /** The auto-generated id of the user group master */
    user_group_id: number;
    /** The user group name with 255 character limit */
    user_group_name: string;
    /** The auto-generated id of the application module master */
    application_module_id: number;
    /** The auto-generated id of the user type master */
    user_type_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    menu_list: SelectApplicationMenuForUserGroupOutputData[];
    status: number;
}

